'use strict';exports.__esModule = true;var classNameCreator = function classNameCreator(icon) {return 'icon-' + icon;};
var classCreator = function classCreator(icon) {return '.' + classNameCreator(icon);};

var nextIconName = exports.nextIconName = function nextIconName(isMobile) {return isMobile ? 'next-arrow' : 'next';};
var prevIconName = exports.prevIconName = function prevIconName(isMobile) {return isMobile ? 'back' : 'prev';};

var getNextIcon = exports.getNextIcon = function getNextIcon(isMobile, isRtl) {return (
    isRtl ? classCreator(prevIconName(isMobile)) : classCreator(nextIconName(isMobile)));};

var getPrevIcon = exports.getPrevIcon = function getPrevIcon(isMobile, isRtl) {return (
    isRtl ? classCreator(nextIconName(isMobile)) : classCreator(prevIconName(isMobile)));};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/arrowIconIdentifier.js
// module id = 576
// module chunks = 0